import * as React from 'react'
import { t } from 'ttag'
import { ROUTES } from '../../common/Routes/routePaths'
import YumButton from '../../components/YumButton/YumButton'
import Typography from '@material-ui/core/Typography'
import { Box } from '@material-ui/core'
import { YumLanguageSelection } from '../../components/YumLanguageSelection/YumLanguageSelection'
import A11ySettingsButton from '../../components/A11ySettingsDialog/A11ySettingsButton'
import Grid from '@material-ui/core/Grid'
import { Card } from '../../components/Card/Card'
import './Welcome.scss'
import Loader from '../../components/Loader/Loader'
import { Lang, UserProfileDto } from '../../services/api.types'
import { openPrivacyPolicy, openTermsOfService } from '../../common/helpers/routeHelpers'
import { currentLang } from '../../i18nInit'
import YumGrid from '../../components/YumGrid/YumGrid'
import { DesktopSidebar } from '../../components/DesktopSidebar/DesktopSidebar'

//import BadgeLeft from './badges/g2-badge-left.svg'
//import BadgeRight from './badges/g2-badge-right.svg'

export interface IStateProps {
  authenticated: boolean
  userDto: UserProfileDto
}

export interface IDispatchProps {
  reLocate(): void
}

type IWelcomeProps = IStateProps & IDispatchProps

export const WelcomeSidebar = (props: { className?: string }) => {
  const secondTitle = t`We don't just
talk the talk`
  return currentLang === Lang.EN ? (
    <Box display={{ xs: 'none', md: 'block' }} style={{ background: '#F2F2F6', width: '50%' }}>
      <div style={{ padding: '100px', textAlign: 'center' }}>
        <Typography variant="h1" component="h2" style={{ textAlign: 'center' }}>
          {secondTitle}
        </Typography>

        <Typography
          variant="subtitle1"
          component="p"
          style={{ textAlign: 'center' }}
        >{t`The recognition we have earned proves that we walk the walk.`}</Typography>

        <YumGrid style={{ marginTop: '30px', marginBottom: '30px' }}>
          <img
            style={{ width: '130px', height: '150px' }}
            width="130"
            height="150"
            src="https://resources.yumuuv.com/badges/first-badge.svg"
            alt="G2 Spring 2026 Leader badge"
          />
          <img
            style={{ width: '130px', height: '150px' }}
            width="130"
            height="150"
            src="https://resources.yumuuv.com/badges/second-badge.svg"
            alt="G2 Spring 2026 Best Usability badge"
          />
        </YumGrid>

        <Typography
          variant="subtitle1"
          component="p"
          style={{ textAlign: 'center', marginBottom: 0 }}
        >{t`Join the YuMuuv community and experience the difference.`}</Typography>
      </div>
    </Box>
  ) : (
    <DesktopSidebar />
  )
}

export class Welcome extends React.Component<IWelcomeProps> {
  componentDidMount() {
    document.body.classList.add('show-illustration')
    this.props.reLocate()
  }

  componentDidUpdate() {
    if (this.props.authenticated) {
      this.props.reLocate()
    }
  }

  componentWillUnmount(): void {
    document.body.classList.remove('show-illustration')
  }

  render() {
    const title = t`Welcome
          to YuMuuv`
    return (
      <Card className="welcome pt-12">
        <Box className="welcome__inner" style={{ position: 'relative' }}>
          <Loader />
          <div className="welcome__form">
            <Box display={{ xs: 'block', md: 'none' }}>
              <Grid
                container
                alignItems="center"
                justifyContent="flex-end"
                direction="row"
                style={{ gap: '4px', marginBottom: '24px' }}
              >
                <A11ySettingsButton />
                <YumLanguageSelection />
              </Grid>
            </Box>

            <Typography className={'h1-desktop-single-line'} variant="h1" style={{ textAlign: 'center' }}>
              {title}
            </Typography>

            <Typography
              variant="subtitle1"
              component="p"
              style={{ textAlign: 'center' }}
            >{t`Connect device. Be active. Enjoy progress.`}</Typography>

            <YumButton style={{ width: '225px', marginBottom: '16px' }} to={ROUTES.LOGIN.to}>{t`Log in`}</YumButton>
            <YumButton
              variant="outlined"
              style={{ width: '225px', marginBottom: '8px' }}
              to={ROUTES.SIGNUP.to}
            >{t`Sign up`}</YumButton>

            <Box component="footer" display={{ xs: 'block', md: 'none' }}>
              <Box
                component="ul"
                display="flex"
                flexDirection="column"
                alignItems="center"
                style={{ listStyle: 'none', padding: 0, margin: 0 }}
              >
                <Box component="li" p="6px 15px 8px 15px">
                  <button
                    role="link"
                    type="button"
                    className={'link-blue'}
                    onClick={openPrivacyPolicy}
                  >{t`Privacy Policy`}</button>
                </Box>
                <Box component="li" p="0 15px 8px 15px">
                  <button
                    role="link"
                    type="button"
                    style={{ marginTop: 5 }}
                    className={'link-blue'}
                    onClick={openTermsOfService}
                  >{t`Terms of Service`}</button>
                </Box>
              </Box>
            </Box>
          </div>

          <Box
            component="footer"
            display={{ xs: 'none', md: 'block' }}
            style={{ position: 'absolute', bottom: 20, left: 0, right: 0 }}
          >
            <Box
              component="ul"
              display="flex"
              justifyContent="center"
              style={{ listStyle: 'none', padding: 0, margin: 0 }}
            >
              <Box component="li" p="6px 15px 8px 15px">
                <button
                  role="link"
                  type="button"
                  style={{ margin: '0 12px' }}
                  className={'link-blue'}
                  onClick={openPrivacyPolicy}
                >{t`Privacy Policy`}</button>
              </Box>
              <Box component="li" p="6px 15px 8px 15px">
                <button
                  role="link"
                  type="button"
                  style={{ margin: '0 12px' }}
                  className={'link-blue'}
                  onClick={openTermsOfService}
                >{t`Terms of Service`}</button>
              </Box>
            </Box>
          </Box>
        </Box>
        <WelcomeSidebar />
      </Card>
    )
  }
}
